import { useEffect, useState } from "react";

function Navbar({
  showNavbar,
  page,
  isLoggedIn,
  goHome,
  goSearch,
  goAdmin,
  goDashboard,
  handleLogout,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [page, isLoggedIn, showNavbar]);

  const closeMenu = () => setIsMenuOpen(false);

  const handleHome = () => {
    closeMenu();
    goHome();
  };

  const handleSearch = () => {
    closeMenu();
    goSearch();
  };

  const handleAdmin = () => {
    closeMenu();
    goAdmin();
  };

  const handleDashboard = () => {
    closeMenu();
    goDashboard();
  };

  const onLogout = () => {
    closeMenu();
    handleLogout();
  };

  return (
    <>
      <header className={`nav-wrap ${showNavbar ? "nav-visible" : "nav-hidden"}`}>
        <nav className="navbar relative overflow-hidden rounded-b-2xl bg-[linear-gradient(145deg,rgba(16,61,98,0.96),rgba(23,86,133,0.94))] shadow-[0_18px_35px_rgba(7,39,68,0.42)] backdrop-blur-xl">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_14%_22%,rgba(255,255,255,0.16),transparent_34%),radial-gradient(circle_at_82%_24%,rgba(120,188,235,0.2),transparent_30%),radial-gradient(circle_at_66%_82%,rgba(93,162,212,0.16),transparent_28%)]" />
          <button
            className="brand-btn relative z-10 rounded-xl px-2 py-1 transition-transform duration-300 hover:-translate-y-0.5"
            type="button"
            onClick={handleHome}
          >
            <span className="brand-mark shadow-[0_8px_18px_rgba(49,137,209,0.35)]">AY</span>
            <span className="brand-text">
              <strong>Aksh Yadav</strong>
              <small>Portfolio Blog</small>
            </span>
          </button>
          <button
            type="button"
            className={`nav-menu-toggle relative z-10 ${isMenuOpen ? "is-open" : ""}`}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((current) => !current)}
          >
            <span className="menu-glyph" aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
          </button>
          <div className={`nav-links relative z-10 ${isMenuOpen ? "is-open" : ""}`}>
            <button
              className={`nav-link search-trigger ${page === "search" ? "active" : ""}`}
              onClick={handleSearch}
              type="button"
              aria-label="Search blogs"
              title="Search blogs"
            >
              <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
                <path
                  d="M10.5 4.5a6 6 0 1 1 0 12a6 6 0 0 1 0-12Zm0-2a8 8 0 1 0 4.9 14.3l5 5a1 1 0 1 0 1.4-1.4l-5-5A8 8 0 0 0 10.5 2.5Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            {!isLoggedIn && (
              <button
                className={`nav-link nav-link-admin ${page === "admin" ? "active" : ""}`}
                onClick={handleAdmin}
                type="button"
              >
                Admin Login
              </button>
            )}
            {isLoggedIn && (
              <>
                <button
                  className={`nav-link ${page === "dashboard" ? "active" : ""}`}
                  onClick={handleDashboard}
                  type="button"
                >
                  Dashboard
                </button>
                <button
                  className={`nav-link ${page === "admin" ? "active" : ""}`}
                  onClick={handleAdmin}
                  type="button"
                >
                  Create Blog
                </button>
                <button className="nav-link logout" onClick={onLogout} type="button">
                  Logout
                </button>
              </>
            )}
          </div>
        </nav>
      </header>
      <div className="nav-spacer" />
    </>
  );
}

export default Navbar;
